// extracted by mini-css-extract-plugin
module.exports = {"font":"styles_font__3OzmV","container-overrides":"styles_container-overrides__3xEy2"};